import { api } from './client'
import type { FieldDefinition, FieldOption } from './types'

/** Mirrors backend FieldDefinitionRequest. entityType/fieldKey are immutable after create. */
export interface FieldDefinitionInput {
  entityType: 'contact' | 'deal'
  fieldKey: string
  label: string
  dataType: string
  options?: FieldOption[] | null
  required?: boolean
  position?: number
  hidden?: boolean
}

export async function listFieldDefinitions(
  entityType?: 'contact' | 'deal',
): Promise<FieldDefinition[]> {
  const { data } = await api.get<FieldDefinition[]>('/api/field-definitions', {
    params: { entityType },
  })
  return data
}

export async function createFieldDefinition(input: FieldDefinitionInput): Promise<FieldDefinition> {
  const { data } = await api.post<FieldDefinition>('/api/field-definitions', input)
  return data
}

export async function updateFieldDefinition(
  id: string,
  input: FieldDefinitionInput,
): Promise<FieldDefinition> {
  const { data } = await api.put<FieldDefinition>(`/api/field-definitions/${id}`, input)
  return data
}

export async function deleteFieldDefinition(id: string): Promise<void> {
  await api.delete(`/api/field-definitions/${id}`)
}

/** New display order (0..n) for an entity type's custom fields. Returns the reordered list. */
export async function reorderFieldDefinitions(
  entityType: 'contact' | 'deal',
  ids: string[],
): Promise<FieldDefinition[]> {
  const { data } = await api.put<FieldDefinition[]>('/api/field-definitions/reorder', {
    entityType,
    ids,
  })
  return data
}
